"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var SVG_1 = __importDefault(require("./SVG"));
var Icon = styled_components_1.default(SVG_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    polygon,\n    rect {\n        ", "\n    }\n"], ["\n    polygon,\n    rect {\n        ",
    "\n    }\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    if (disabled) {
        return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                    fill: ", ";\n                "], ["\n                    fill: ", ";\n                "])), theme.colorControlIconDisabled);
    }
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                fill: ", ";\n            "], ["\n                fill: ", ";\n            "])), theme.colorControlElement);
});
var Checkbox = function (_a) {
    var disabled = _a.disabled, mode = _a.mode;
    return (react_1.default.createElement(Icon, { disabled: disabled, viewBox: "0 0 20 20", width: "20px", height: "20px" },
        mode === 'selected' && (react_1.default.createElement("polygon", { "data-selector-id": "grid-checkbox-selected-polygon", points: "8 15.5 17 6.5 15 4.5 8 11.5 5 8.5 3 10.5 8 15.5" })),
        react_1.default.createElement("path", { "data-selector-id": "grid-checkbox-path", d: "M0,0V20H20V0ZM19,19H1V1H19Z" }),
        mode === 'indeterminate' && (react_1.default.createElement("rect", { "data-selector-id": "grid-checkbox-selected-rect", x: "5", y: "5", width: "10", height: "10" }))));
};
exports.default = Checkbox;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Checkbox.js.map